import * as React from "react";
import Svg, { G, Path, Circle } from "react-native-svg";

function SvgComponent(props) {
  if (props?.type === "SUCCESS") {
    return (
      <Svg
        width={12}
        height={10}
        viewBox="0 0 12 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <G fill="#000">
          <Path d="M7.75 6.986H1.34l.007-.008L2.47 5.836a.5.5 0 10-.713-.7L.636 6.274a8.525 8.525 0 00-.311.338 1.294 1.294 0 000 1.715c.116.13.23.256.309.335l1.122 1.142a.5.5 0 00.713-.7L1.372 7.986H7.75a.5.5 0 000-1zM4.25 2.986h6.377L9.53 4.102a.5.5 0 10.713.7l1.12-1.14a8.83 8.83 0 00.312-.337 1.294 1.294 0 000-1.714 8.557 8.557 0 00-.309-.335L10.243.136a.5.5 0 00-.713.7l1.126 1.145.004.005H4.25a.5.5 0 000 1z" />
        </G>
      </Svg>
    );
  } else {
    return (
      <Svg
        width={14}
        height={14}
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <Circle cx={7} cy={7} r={7} fill="#FB9800" />
        <Path
          d="M7.003 8.38c-.539 0-.808-.32-.824-.87l-.1-3.32c0-.085-.005-.181-.005-.25 0-.593.348-.94.934-.94.58 0 .923.347.923.94 0 .069-.005.165-.01.25l-.095 3.32c-.016.55-.29.87-.823.87zm0 2.62C6.449 11 6 10.578 6 10.04c0-.534.449-.956 1.003-.956.548 0 .997.422.997.955 0 .54-.449.961-.997.961z"
          fill="#fff"
        />
      </Svg>
    );
  }
}

export default SvgComponent;
